import { Link } from "react-router-dom";
import { PageHero } from "@/components/PageHero";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";
import { IMG } from "@/data/site";

const stats = [
  ["2", "Hotels across Tanzania"],
  ["19+", "Real moments in our gallery"],
  ["24/7", "Guest services & transfers"],
  ["5★", "Guest-rated hospitality"],
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero overline="About Us" title="Zuri Sana Hotel" subtitle="African Luxury. World-Class Hospitality. On the island of Zanzibar." image={IMG.hotelBungalows} />
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <FadeUp>
          <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] mb-4">Who We Are</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl font-light text-white leading-tight">Tanzanian at heart, world-class in standard</h2>
          <p className="mt-6 text-[#a3a3a3] leading-relaxed">
            Zuri Sana Hotel is the Zanzibar home of the Zuri Sana Hospitality Group — blending modern sophistication with authentic Tanzanian cultural heritage. Set among garden bungalows steps from the beach, we deliver personalised, unique experiences for every guest, with a deep commitment to environmental sustainability and community support.
          </p>
          <p className="mt-4 text-[#a3a3a3] leading-relaxed">
            Under the leadership of CEO Khalid Abdulkhakim Salama, the group also operates the Golden Pigeon Hotel in Mwanza — together pursuing one vision: to be the leading destination for luxury hospitality in Africa.
          </p>
          <div className="mt-10 flex gap-4">
            <Link to="/our-story" className="btn-outline-gold px-7 py-3.5 text-[12px] tracking-[0.18em] uppercase" data-testid="about-story-btn">Our Story</Link>
            <Link to="/team" className="btn-outline-gold px-7 py-3.5 text-[12px] tracking-[0.18em] uppercase" data-testid="about-team-btn">Meet the Team</Link>
          </div>
        </FadeUp>
        <FadeUp delay={0.15} className="img-zoom aspect-[4/5]">
          <img src={IMG.beachView} alt="The beach at Zuri Sana Hotel, Zanzibar" className="w-full h-full object-cover" />
        </FadeUp>
      </section>
      <section className="border-y hairline bg-[#0d0d0d]">
        <Stagger className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-2 lg:grid-cols-4 gap-10">
          {stats.map(([num, label]) => (
            <StaggerItem key={label} className="text-center">
              <p className="font-serif-display text-5xl md:text-6xl font-light gold-text">{num}</p>
              <p className="mt-2 text-sm text-white/50">{label}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </div>
  );
}
